(function() {
  class AlClientsGallery extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('[data-carousel]');
      this.track = this.querySelector('.al-clients-track');
      this.slides = Array.from(this.querySelectorAll('.al-clients-slide'));
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      this.counter = this.querySelector('.al-clients-count');
      this.compactQuery = window.matchMedia('(max-width: 560px)');
      this.index = this.slides.length >= 5 ? 2 : this.slides.length >= 3 ? 1 : 0;
      this.onLayoutChange = () => this.showSlide(this.index);
      this.compactQuery.addEventListener?.('change', this.onLayoutChange);
      this.swiped = false;

      if (this.carousel && this.slides.length) {
        this.prevBtn?.addEventListener('click', () => this.showSlide(this.index - 1));
        this.nextBtn?.addEventListener('click', () => this.showSlide(this.index + 1));
        this.carousel.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showSlide(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        let touchX = null;
        this.carousel.addEventListener('touchstart', (event) => {
          touchX = event.changedTouches[0]?.clientX ?? null;
        }, { passive: true });
        this.carousel.addEventListener('touchend', (event) => {
          if (touchX === null) return;
          const delta = event.changedTouches[0].clientX - touchX;
          touchX = null;
          if (Math.abs(delta) < 45) return;
          this.swiped = true;
          this.showSlide(this.index + (delta < 0 ? 1 : -1));
          window.setTimeout(() => { this.swiped = false; }, 350);
        }, { passive: true });
        this.showSlide(this.index);
      }

      this.lightbox = this.querySelector('.al-clients-lb');
      if (!this.lightbox) return;
      this.lightboxImg = this.querySelector('.al-clients-lb-img');
      this.lightboxStars = this.querySelector('.al-clients-lb-stars');
      this.lightboxText = this.querySelector('.al-clients-lb-text');
      this.lightboxWho = this.querySelector('.al-clients-lb-who');
      this.closeBtn = this.querySelector('.al-clients-lb-close');
      this.shots = this.querySelectorAll('.al-clients-shot');

      this.shots.forEach((shot) => {
        shot.addEventListener('click', () => {
          if (this.swiped) return;
          const img = shot.querySelector('img');
          this.openLightbox(shot.dataset.fullSrc || img.src, img.alt,
            shot.dataset.testimonial || '', shot.dataset.customerName || '',
            shot.dataset.customerLocation || '', shot.dataset.showRating === 'true');
        });
      });
      this.closeBtn.addEventListener('click', () => this.closeLightbox());
      this.lightbox.addEventListener('click', (event) => {
        if (event.target === this.lightbox) this.closeLightbox();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.lightbox.classList.contains('open')) this.closeLightbox();
      });
    }

    disconnectedCallback() {
      this.compactQuery?.removeEventListener?.('change', this.onLayoutChange);
    }

    showSlide(index) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      this.index = (index + count) % count;
      const visibleCount = Math.min(count, this.compactQuery.matches ? 3 : 5);
      const centerOffset = Math.floor(visibleCount / 2);
      const firstIndex = (this.index - centerOffset + count) % count;

      this.slides.forEach((slide) => {
        slide.hidden = true;
        slide.classList.remove('is-center');
        slide.setAttribute('aria-hidden', 'true');
        const button = slide.querySelector('.al-clients-shot');
        if (button) button.tabIndex = -1;
      });

      for (let position = 0; position < visibleCount; position++) {
        const slide = this.slides[(firstIndex + position) % count];
        this.track.appendChild(slide);
        slide.hidden = false;
        slide.classList.toggle('is-center', position === centerOffset);
        slide.setAttribute('aria-hidden', 'false');
        const button = slide.querySelector('.al-clients-shot');
        if (button) button.tabIndex = 0;
      }

      this.carousel.dataset.count = String(visibleCount);
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + count;
      const hasMultiple = count > 1;
      if (this.prevBtn) this.prevBtn.hidden = !hasMultiple;
      if (this.nextBtn) this.nextBtn.hidden = !hasMultiple;
    }

    openLightbox(src, alt, testimonial, customerName, customerLocation, showRating) {
      this.lightboxImg.src = src;
      this.lightboxImg.alt = alt;
      this.lightboxStars.textContent = showRating ? '★★★★★' : '';
      this.lightboxStars.style.display = showRating ? 'block' : 'none';
      this.lightboxText.textContent = testimonial;
      this.lightboxWho.querySelector('b').textContent = customerName;
      this.lightboxWho.querySelector('span').textContent = customerLocation;
      this.previousOverflow = document.body.style.overflow;
      this.lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
      this.closeBtn.focus();
    }

    closeLightbox() {
      this.lightbox.classList.remove('open');
      document.body.style.overflow = this.previousOverflow || '';
      this.lightboxImg.removeAttribute('src');
      this.slides[this.index]?.querySelector('.al-clients-shot')?.focus();
    }
  }
  if (!customElements.get('al-clients-gallery')) {
    customElements.define('al-clients-gallery', AlClientsGallery);
  }
})();
